var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVG",
    clipPath: "url(#clip0_400_2672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M41.9977 84.148C65.1223 84.148 83.8684 65.4018 83.8684 42.2772C83.8684 19.1527 65.1223 0.406494 41.9977 0.406494C18.8731 0.406494 0.126953 19.1527 0.126953 42.2772C0.126953 65.4018 18.8731 84.148 41.9977 84.148Z",
    fill: "#BD3902"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M41.9968 83.6824C64.8645 83.6824 83.4024 65.1445 83.4024 42.2769C83.4024 19.4092 64.8645 0.871338 41.9968 0.871338C19.1292 0.871338 0.591309 19.4092 0.591309 42.2769C0.591309 65.1445 19.1292 83.6824 41.9968 83.6824Z",
    stroke: "#EC7904",
    strokeWidth: 0.93046
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M59.0129 39.048C61.202 40.6093 61.202 43.862 59.0129 45.4234L36.3909 61.5573C33.7992 63.4056 30.2021 61.5529 30.2021 58.3697L30.2022 26.1017C30.2022 22.9183 33.7992 21.0656 36.3909 22.914L59.0129 39.048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_400_2672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.c3f6e4254be2a75b6ab2f24d8c0b42fb.svg";
export { ForwardRef as ReactComponent };